import { system } from 'styled-system';
import { getPxAbsolute } from '../internal';

const borderBottomLeftRadius = system({
  radiusTL: {
    property: 'borderTopLeftRadius',
    scale: 'radii',
    transform: getPxAbsolute,
  },
});

export default borderBottomLeftRadius;
